<template>
    <div class="form-feed">
        <div
            v-if="!isSchedulingFormEdit"
            class="gcmcn-form-title"
        >
            Add Scheduling
        </div>
        <div
            v-else
            class="gcmcn-form-title"
        >
            Edit Scheduling
        </div>
        <div
            v-if="formInitialised"
            class="gcmcn-card form-feed"
        >
            <el-form :model="form" :rules="rules" ref="form">
                <div class="gcmcn-inputs-container"  style="justify-content: flex-start;">
                    <div class="flex-basis-4" style="margin-right: 15px;">
                        <el-form-item class="gcmcn-form-input" prop="start_date">
                            <div class="gcmcn-form-label">Start date</div>
                            <el-date-picker
                                v-model="form.start_date"
                                popper-class="gcmcn-popper"
                                type="date"
                                size="mini"
                                placeholder="Select a date"
                                :disabled="disableEditStartDateInput"
                                @change="handleStartDateChange"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-4">
                        <el-form-item class="gcmcn-form-input" prop="start_time">
                            <div class="gcmcn-form-label">At</div>
                            <ns-time-picker
                                v-model="form.start_time"
                                :disabled="disableEditStartDateInput"
                                :display-seconds="false"
                                :display-digital-clock="true"
                            ></ns-time-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="gcmcn-inputs-container" style="justify-content: flex-start;">
                    <div class="flex-basis-4" style="margin-right: 15px;">
                        <el-form-item class="gcmcn-form-input" prop="end_date">
                            <div class="gcmcn-form-label">End date</div>
                            <el-date-picker
                                v-model="form.end_date"
                                popper-class="gcmcn-popper"
                                type="date"
                                size="mini"
                                placeholder="Select a date"
                                :pickerOptions="pickerOptions"
                                @change="handleEndDateChange"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-4">
                        <el-form-item class="gcmcn-form-input" prop="end_time">
                            <div class="gcmcn-form-label">At</div>
                            <ns-time-picker
                                v-model="form.end_time"
                                :display-seconds="false"
                                :display-digital-clock="true"
                            ></ns-time-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="text-right">
                    <el-button
                        type="text"
                        :loading="loading"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        type="primary"
                        class="gcmcn-primary-btn small"
                        :loading="loading"
                        @click="validateForm">Save</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import NsTimePicker from 'fundation-app-vuejs/src/components/partials/ns-time-picker.vue';

export default {

    components: {
        NsTimePicker,
    },

    props: {
        scheduling:{
            type: Object,
            default: null,
        },
        channel:{
            type:Object,
            required: true,
        },
        disableEditStartDate:{
            type: Boolean,
            default: false,
        },
        isSchedulingFormEdit:{
            type: Boolean,
            default: false,
        },
        minDurationParameter:{
            type: Number,
            required: true,
        },

    },

    data (){
        return {
            loading: false,
            form: {
                start_date:'',
                end_date:'',
            },
            formInitialised: false,
            requestSchedulingTimeoutId: null,
        };
    },

    computed: {

        rules (){
            let rules = {
                start_date: [{ required: true, message: 'Start date is required' }],
                end_date: [{ validator: this.validEndDate }],
                start_time: [{ validator: this.validStartTime }],
                end_time: [{ validator: this.validEndTime }],
            };
            return rules;
        },
        pickerOptions (){
            return {
                disabledDate: (time) => {
                    // We use new Date with moment because we need to handle utc date with moment and el-date-picker only handle Date objects
                    let startDate = moment(this.form.start_date).format('YYYY-MM-DD');
                    return time.getTime() < new Date(moment(startDate).utc());
                },
            };
        },
        disableEditStartDateInput(){
            if(this.isSchedulingFormEdit){
                if(this.scheduling.status === 'RUNNING' || this.disableEditStartDate){
                    return true;
                }
            }
            return false;
        }
    },

    watch: {
        rules: {
            handler (){
                this.$nextTick( () => {
                    this.$refs.form.clearValidate();
                });
            },
            deep: true,
        },
    },
    mounted(){
        this.setForm();
    },
    methods: {
        handleStartDateChange(date){
            this.form.start_date = new Date(moment(date).format('YYYY-MM-DD'));
        },
        handleEndDateChange(date){
            this.form.end_date = new Date(moment(date).format('YYYY-MM-DD'));
        },
        validStartTime (rule, value, callback) {
            if(!this.form.start_time){
                return callback(new Error('Start time is required'));
            }else if(!this.form.start_time.match(/^([0-1][0-9]|2[0-3]|[0-9])\:([0-5][0-9]|[1-9])$/gm)){
                return callback(new Error('Start time format must match HH:mm pattern'));
            }
            callback();
        },
        validEndDate (rule, value, callback) {
            if(!this.form.end_date){
                return callback(new Error('End date is required'));
            }
            let startDateIsBefore = new Date(this.form.start_date) <= new Date(this.form.end_date);
            if(!startDateIsBefore){
                return callback(new Error('End date must be after start date'));
            }
            callback();
        },
        validEndTime (rule, value, callback) {
            if(!this.form.end_time){
                return callback(new Error('End time is required'));
            }else if(!this.form.end_time.match(/^([0-1][0-9]|2[0-3]|[0-9])\:([0-5][0-9]|[1-9])$/gm)){
                return callback(new Error('End time format must match HH:mm pattern'));
            }
            let isSameDate = moment(this.form.end_date).isSame(this.form.start_date);
            let endTimeIsBefore = this.form.end_time < this.form.start_time;
            if(isSameDate && endTimeIsBefore){
                return callback(new Error('End time musn\'t be before start time'));
            }
            let start = moment(this.form.start_time, 'HH:mm');
            let end = moment(this.form.end_time, 'HH:mm');
            let duration = moment(end.diff(start)).subtract(1, 'hours').format('HH:mm');
            let minDurationInMinutes = moment(`00:${this.minDurationParameter}`, 'HH:mm').format('HH:mm');
            if( isSameDate && duration < minDurationInMinutes){
                return callback(new Error(`End time must  be at least ${this.minDurationParameter} min after start time`));
            }
            callback();
        },
        authorizedCharacters(rule, value, callback) {
            if(!this.form.display_name) {
                return callback(new Error('Name is required'));
            } else if (!this.form.display_name.match(this.$store.getters.authorizedCharactersRegex)) {
                return callback(new Error('Invalid name'));
            } else {
                callback();
            }
        },
        setForm (){
            if(this.isSchedulingFormEdit){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.scheduling)));
                this.form.start_time = moment.utc(this.form.start_date).format('HH:mm');
                this.form.end_time = moment.utc(this.form.end_date).format('HH:mm');
                this.$set(this.form, 'start_date', moment(this.scheduling.start_date).utc().format('YYYY-MM-DD'));
                this.$set(this.form, 'end_date', moment(this.scheduling.end_date).utc().format('YYYY-MM-DD'));
            }else{
                this.$set(this, 'form', {
                    start_date: '',
                    end_date: '',
                    start_time: '',
                    end_time: '',
                });
            }
            this.formInitialised = true;
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let form = JSON.parse(JSON.stringify(this.form));
                    form.start_time = moment.utc(this.form.start_time, 'HH:mm:ss').format('HH:mm:ss');
                    form.end_time = moment.utc(this.form.end_time, 'HH:mm:ss').format('HH:mm:ss');
                    let startTimeSplitted = form.start_time.split(':');
                    let endTimeSplitted = form.end_time.split(':');
                    form.start_date = moment(form.start_date).set({
                        hours: startTimeSplitted[0],
                        minutes: startTimeSplitted[1],
                        seconds: startTimeSplitted[2],
                    }).format('YYYY-MM-DDTHH:mm:ss');
                    form.end_date = moment(form.end_date).set({
                        hours: endTimeSplitted[0],
                        minutes: endTimeSplitted[1],
                        seconds: endTimeSplitted[2],
                    }).format('YYYY-MM-DDTHH:mm:ss');
                    form.channel_uid = this.channel.uid;
                    let postData = { item: form };
                    postData.scopes = {'X-Entity-Uid': this.channel.scopes.entity_uid};
                    let actionType = this.isSchedulingFormEdit ? 'edition' : 'creation';
                    let action = 'createItem';
                    if(this.isSchedulingFormEdit){
                        postData.item.scheduling_uid = this.scheduling.uid;
                        postData.item.status = 'PENDING';
                        postData.url = this.$store.state.api.meta.listModels.schedulingModificationRequest.url;
                        postData.model = 'schedulingModificationRequest';
                    }else{
                        postData.item.channel_uid = this.channel.uid;
                        postData.url = this.$store.state.api.meta.listModels.schedulingCreationRequest.url;
                        postData.model = 'schedulingCreationRequest';
                    }
                    return this.$store.dispatch(action, postData).then((res) => {
                        this.watchSchedulingsModificationRequest(res.url);
                    }).catch((e) => {
                        console.error(e);
                        this.$message.error(`Error on scheduling ${actionType}.`);
                        this.loading = false;
                    });
                }
            });
        },
        watchSchedulingsModificationRequest(requestUrl){
            this.loading = true;
            clearTimeout(this.requestSchedulingTimeoutId);
            let actionType = this.isSchedulingFormEdit ? 'edited' : 'created';
            this.$store.dispatch('remoteGet', {
                url: requestUrl
            }).then(res => {
                if (res.data && ['COMPLETED'].includes(res.data.status)) {
                    this.$message({
                        message: `scheduling ${actionType}!`,
                        type: 'success'
                    });
                    this.$emit('scheduling-created');
                    this.loading = false;
                }
                else if (res.data && ['FAILED'].includes(res.data.status)) {
                    console.error();
                    this.$message.error(`Error on scheduling ${actionType}`);
                    this.loading = false;
                } else {
                    this.requestSchedulingTimeoutId = setTimeout(() => {
                        this.watchSchedulingsModificationRequest(requestUrl);
                    }, 3000);
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
    },
};
</script>

<style lang="scss">
.form-feed{
    .el-switch__label:not(.is-active){
        color: #858d96;
    }
    .crop-rules{
        text-transform: initial;
        color: #bbb;

    }
    .gcmcn-danger-btn{
        margin-top: 20px;
        margin-bottom: 20px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/SchedulingsView/scheduling-form.vue